import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export const BranchTransferButton = ({ size = "lg", className = "" }) => {
  const navigate = useNavigate();
  const [t, setT] = useState(null);
  useEffect(() => { api.get("/branch-transfer/mine").then((r) => setT(r.data)).catch(() => setT(null)); }, []);
  if (!t?.enabled) return null;
  const go = () => navigate("/book", {
    state: { transfer: true, rebook: { pickup: t.from.address, dropoff: t.to.address, items: [{ size: "small", quantity: 1 }], service: "standard" } },
  });
  return (
    <Button size={size} onClick={go} data-testid="branch-transfer-button" className={`gap-2 bg-kilted-gold text-kilted-green hover:bg-kilted-goldLight ${className}`}>
      <ArrowLeftRight className="h-4 w-4" /> Transfer to {t.to.name || t.to.address.city}
    </Button>
  );
};
